import React, { useEffect, useState } from "react";
import { useParams, Link } from 'react-router-dom';

function InfosMedia() {
  const { nom } = useParams();

  const [loading, setLoading] = useState(true);
  const [media, setMedia] = useState([]);
  const [showMedias, setShowMedias] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (nom) {
          const response = await fetch(`/media/infos/${nom}`);
          const data = await response.json();
          setMedia(data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    }


    fetchData();
  }, [nom]);

  const [films, setFilms] = useState([]);


  useEffect(() => {
    if (media) {
      fetch(`/media/list-${media.type}s`)
        .then((response) => response.json())
        .then((data) => {
          // Shuffle the array randomly
          const shuffledFilms = [...data].sort(() => Math.random() - 0.5);
          setFilms(shuffledFilms);
          // Show the films with a delay of 200ms between each film after 2 seconds
          setTimeout(() => {
            setShowMedias(true);
          }, 800);
        })
        .catch((error) => console.error("Server error"));
    }
  }, [media]);


  return (
    <section className="details_media">
      <div className="container_news">
        {loading && <div className="spinner"></div>}
        {!loading && (
          <>
            <div className="media-preview" style={{ backgroundImage: `url(${media.url})` }}></div>
            <div className="champ-desc">
              <h4 className="title-media">{media.nom}</h4>
              <p>Lorem ipsum dolor, sit amet consectetur adipisicing elit. Fugiat, ad placeat maxime, incidunt quisquam quasi possimus optio numquam quaerat vero maiores, voluptates accusantium nesciunt similique facilis accusamus illo. Fugiat, tenetur.</p>
            </div>
            <div className="champ-desc">
              <h4>Durée du media</h4>
              <p>{media.duree}</p>
            </div>
            <div className="champ-desc">
              <h4>Genre du media</h4>
              <p>{media.genre}</p>
            </div>
            <div className="champ-desc other">
              <h4>Autres media</h4>
              <div className="list-mini-card">
                {films.map((film, index) => (
                  <div key={film._id} className={` mini-card  ${showMedias ? 'fadeIn' : ''}`}
                    style={{
                      backgroundImage: `url(${film.url})`,
                      animationDelay: `${100 * index}ms`,
                    }}>
                    <p>{film.nom}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="liste_series">
              {media.type === 'serie' && media.seasons.map((season, seasonIndex) => (
                <div key={seasonIndex}>
                  <h4>Saison {season.seasonNumber}</h4>
                  <div className="liste series">
                    {season.episodes.map((episode, index) => (
                      <Link key={index} to={`/video/${media.nom}/${seasonIndex}/${index}`} rel="noopener noreferrer" className={`carte ${showMedias ? 'fadeIn' : ''}`} style={{ backgroundImage: `url(${media.url})`, animationDelay: `${100 * index}ms` }}>
                        <h3>Épisode {index + 1}</h3>
                      </Link>
                    ))}
                  </div>
                </div>
              ))}
              {media.type !== 'serie' && (
                <div className="champ-desc">
                  <Link to={`/video/${media.nom}`} className="btn-lecture">
                    Voir le média
                  </Link>
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </section>
  );


}

export default InfosMedia;
